<!-- Page Search -->
<app-dashboard-search></app-dashboard-search>

<app-dashboard-summary></app-dashboard-summary>
<!-- Page Widgets -->
<app-dashboard-widgets></app-dashboard-widgets>
